import { render, staticRenderFns } from "./DEVELOPER.vue?vue&type=template&id=aafcac82&"
import script from "./DEVELOPER.vue?vue&type=script&lang=js&"
export * from "./DEVELOPER.vue?vue&type=script&lang=js&"
import style0 from "./DEVELOPER.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports